var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge360",class:{ sm: _vm.small },attrs:{"draggable":"false"}},[_c('CIcon',{staticClass:"badge360logo",attrs:{"alt":"360 logo","draggable":"false","icon":_vm.ci360Logo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }